import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Text } from '../components/base/Text';
import { ThemeToggle } from '../components/product/ThemeToggle';
import { useTheme } from '../hooks';

export const SettingsScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useTheme();

  return (
    <div style={{ padding: 'var(--space-lg)' }}>
      <button
        type="button"
        onClick={() => navigate(-1)}
        style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-accent)', marginBottom: 'var(--space-lg)' }}
      >
        <ArrowLeft size={20} /> {t('common.back', 'Back')}
      </button>
      <Text variant="display" as="h1" style={{ marginBottom: 'var(--space-lg)', color: 'var(--color-text-primary)' }}>
        {t('drawer.settings', 'Settings')}
      </Text>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'var(--space-md)', background: 'var(--color-bg-secondary)', borderRadius: 'var(--radius-md)' }}>
        <Text variant="body">{t('drawer.theme.light')} / {t('drawer.theme.dark')}</Text>
        <ThemeToggle />
      </div>
    </div>
  );
};
